export default {
    items: [
        {
            name: "Dashboard",
            url: "/dashboard",
            icon: "fa fa-dashboard",
            permission: null
        },
        {
            name: "Tableau",
            url: "/tableau",
            icon: "fa fa-pie-chart",
            permission: 1400
        },
        {
            name: "Barang Masuk",
            url: "/barang-masuk",
            icon: "fa fa-truck",
            permission: 700,
            children: [
                {
                    name: "Approve Barang",
                    url: "/barang-masuk/approve",
                    icon: "fa fa-minus",
                    permission: 701
                },
                {
                    name: "Upload Foto / Video V2",
                    url: "/barang-masuk/upload-v2",
                    icon: "fa fa-upload",
                    permission: 702
                },
                {
                    name: "Input Aksesoris",
                    url: "/barang-masuk/input-accesoris",
                    icon: "fa fa-headphones",
                    permission: 703
                },
                {
                    name: "List Titip Jual PGI",
                    url: "/barang-masuk/titip-jual",
                    icon: "fa fa-money",
                    permission: 705
                }
            ]
        },
        {
            name: "Elektronik",
            url: "/elektronik",
            icon: "fa fa-mobile",
            children: [
                {
                    name: "Inventory",
                    url: "/inventory",
                    icon: "fa fa-cubes",
                    permission: 300
                },
                {
                    name: "Inventory Pending",
                    url: "/inventory-pending",
                    icon: "fa fa-cubes",
                    permission: 305
                },
                {
                    name: "History Foto / Video",
                    url: "/history-foto-video",
                    icon: "fa fa-photo",
                    permission: 304
                },
                {
                    name: "Pindah Gudang",
                    url: "/pindah-gudang",
                    icon: "fa fa-archive",
                    permission: 400
                },
                {
                    name: "Adjustment Barcode",
                    url: "/adjustment-barcode",
                    icon: "fa fa-ticket",
                    permission: 500
                },
                {
                    name: "Log Barcode",
                    url: "/log-barcode",
                    icon: "fa fa-book",
                    permission: 600
                },
                {
                    name: "Reset Inventory",
                    url: "/inventory-reset",
                    icon: "fa fa-refresh",
                    permission: 901
                },
                {
                    name: "Temuan Inventaris",
                    url: "/inventory-temuan",
                    icon: "fa fa-search",
                    permission: 902
                }
            ]
        },
        {
            name: "Emas",
            url: "/emas",
            icon: "fa fa-diamond",
            children: [
                {
                    name: "Inventory Emas",
                    url: "/emas/inventory",
                    icon: "fa fa-minus",
                    permission: 1802
                },
                {
                    name: "Terima Emas",
                    url: "/emas/terima",
                    icon: "fa fa-fw fa-cube",
                    permission: 3000
                },
                {
                    name: "Pengiriman Emas",
                    url: "/emas/pengiriman",
                    icon: "fa fa-fw fa-cube",
                    permission: 3003
                },
                {
                    name: "Temuan Emas",
                    url: "/emas/temuan",
                    icon: "fa fa-search",
                    permission: 3001
                },
                {
                    name: "Lebur & Pemurnian Emas",
                    url: "/emas/gold-batches",
                    icon: "fa fa-fire",
                    permission: 1805
                },
                {
                    name: "Request Edit Emas",
                    url: "/emas/edit-emas",
                    icon: "fa fa-edit",
                    permission: 3005
                }
            ]
        },
        {
            name: "Kirim Balik PGI",
            url: "/kirim-balik",
            icon: "fa fa-arrow-left",
            children: [
                {
                    name: "Return Item",
                    url: "/kirim-balik/item",
                    icon: "fa fa-minus",
                    permission: 800
                },
                {
                    name: "Invoice Pengembalian",
                    url: "/kirim-balik/invoice",
                    icon: "fa fa-minus",
                    permission: 801
                },
                {
                    name: "Batal Return Item",
                    url: "/kirim-balik/cancel-item",
                    icon: "fa fa-minus",
                    permission: 802
                },
                {
                    name: "Invoice Pembatalan",
                    url: "/kirim-balik/cancel-invoice",
                    icon: "fa fa-minus",
                    permission: 803
                }
            ]
        },
        {
            name: "Kirim Invent",
            url: "/kirim-inven",
            icon: "fa fa-archive",
            children: [
                {
                    name: "List Kirim Invent",
                    url: "/kirim-inven/list",
                    icon: "fa fa-archive",
                    permission: 1600
                },
                {
                    name: "List Request Invent",
                    url: "/kirim-inven/request",
                    icon: "fa fa-list-alt",
                    permission: 1601
                },
                {
                    name: "List Retur Kirim Invent",
                    url: "/kirim-inven/retur",
                    icon: "fa fa-list-alt",
                    permission: 1602
                }
            ]
        },
        {
            name: "Penjualan",
            url: "/sales",
            icon: "fa fa-dollar",
            children: [
                {
                    name: "Customer",
                    url: "/sales/customer",
                    icon: "fa fa-minus",
                    permission: 200
                },
                {
                    name: "Invoice",
                    url: "/sales/invoice",
                    icon: "fa fa-minus",
                    permission: 201
                },
                {
                    name: "Transaksi",
                    url: "/sales/transactions",
                    icon: "fa fa-minus",
                    permission: 202
                },
                {
                    name: "Transaksi Poin",
                    url: "/sales/point-transactions",
                    icon: "fa fa-minus",
                    permission: 205
                },
                {
                    name: "Daftar Request Void",
                    url: "/sales/request-void",
                    icon: "fa fa-minus",
                    permission: 221
                },
                {
                    name: "Daftar Retur",
                    url: "/sales/retur",
                    icon: "fa fa-minus",
                    permission: 203
                },
                {
                    name: "Daftar Request Retur",
                    url: "/sales/retur-request",
                    icon: "fa fa-minus",
                    permission: 204
                },
                {
                    name: "Daftar Request Overlimit",
                    url: "/sales/overlimit-request",
                    icon: "fa fa-minus",
                    permission: 213
                }
            ]
        },
        {
            name: "Marketplace",
            url: "/marketplace",
            icon: "fa fa-shopping-bag",
            children: [
                {
                    name: "Penjualan",
                    url: "/marketplace/list",
                    icon: "fa fa-minus",
                    permission: 224
                },
                {
                    name: "Retur",
                    url: "/marketplace/returns",
                    icon: "fa fa-minus",
                    permission: 227
                }
            ]
        },
        {
            name: "Shopping Cart",
            url: "/shopping-cart",
            icon: "fa fa-shopping-cart",
            permission: 1200
        },
        {
            name: "Konser Penjualan",
            url: "/konser-penjualan",
            icon: "fa fa-star",
            children: [
                {
                    name: "Daftar Konser",
                    url: "/konser-penjualan/konser",
                    icon: "fa fa-minus",
                    permission: 4001
                },
                {
                    name: "Deposit Konser",
                    url: "/konser-penjualan/deposit",
                    icon: "fa fa-minus",
                    permission: 4000
                },
                {
                    name: "Refund Konser",
                    url: "/konser-penjualan/refund",
                    icon: "fa fa-minus",
                    permission: 4000
                }
            ]
        },
        {
            name: "Laporan",
            url: "/laporan",
            icon: "fa fa-book",
            permission: 1000
        },
        {
            name: "Laporan 3 Bulanan",
            url: "/laporan-3-bulan",
            icon: "fa fa-book",
            permission: 1002
        },
        {
            name: "Stock Report",
            url: "/inventory-report",
            icon: "fa fa-cubes",
            permission: 1100
        },
        {
            name: "Master Data",
            url: "/master",
            icon: "fa fa-wrench",
            children: [
                {
                    name: "Aksesoris",
                    url: "/master/aksesoris",
                    icon: "fa fa-minus",
                    permission: 100
                },
                {
                    name: "Barang",
                    url: "/master/barang",
                    icon: "fa fa-minus",
                    permission: 101
                },
                {
                    name: "Harga Emas",
                    url: "/master/harga-emas",
                    icon: "fa fa-minus",
                    permission: 1800
                },
                {
                    name: "Rumus Umum Grade",
                    url: "/master/rumus-umum-grade",
                    icon: "fa fa-minus",
                    permission: 102
                },
                {
                    name: "Adj. Harga Gudang",
                    url: "/master/adjustment-harga-gudang",
                    icon: "fa fa-minus",
                    permission: 103
                },
                {
                    name: "Adj. Harga Batangan",
                    url: "/master/adjustment-harga-batangan",
                    icon: "fa fa-minus",
                    permission: 108
                },
                {
                    name: "Kategori Kerusakan",
                    url: "/master/kategori-kerusakan",
                    icon: "fa fa-minus",
                    permission: 104
                },
                {
                    name: "Adj. Kerusakan",
                    url: "/master/adjustment-kerusakan",
                    icon: "fa fa-minus",
                    permission: 105
                },
                {
                    name: "Spek Barang",
                    url: "/master/spek",
                    icon: "fa fa-minus",
                    permission: 106
                },
                {
                    name: "Warna Barang",
                    url: "/master/warna",
                    icon: "fa fa-minus",
                    permission: 107
                },
                {
                    name: "Kategori Foto",
                    url: "/master/kategori-foto",
                    icon: "fa fa-minus",
                    permission: 107
                },
                {
                    name: "Biaya Marketplace",
                    url: "/master/marketplace-fee",
                    icon: "fa fa-minus",
                    permission: 111
                },
                {
                    name: "Rumus Harga Marketplace",
                    url: "/master/rumus-harga-marketplace",
                    icon: "fa fa-minus",
                    permission: 112
                },
                {
                    name: "PPH",
                    url: "/master/pph",
                    icon: "fa fa-minus",
                    permission: 1806
                },
                {
                    name: "Materai",
                    url: "/master/materai",
                    icon: "fa fa-minus",
                    permission: 1807
                }
            ]
        },
        {
            name: "Administrasi",
            url: "/admin",
            icon: "fa fa-users",
            children: [
                {
                    name: "User",
                    url: "/admin/user",
                    icon: "fa fa-minus",
                    permission: 1300
                },
                {
                    name: "Role",
                    url: "/admin/role",
                    icon: "fa fa-minus",
                    permission: 1301
                },
                {
                    name: "Divisi",
                    url: "/admin/divisi",
                    icon: "fa fa-minus",
                    permission: 1302
                }
            ]
        },
        {
            name: "TV Commercial",
            url: "/tv-commercial",
            icon: "fa fa-tv",
            permission: 1500
        }
    ]
};
